var _style, _circle, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrashCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 40 40",
    style: {
      enableBackground: "new 0 0 40 40"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#94B8FF;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 20,
    cy: 20,
    r: 20
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M18.3,11.6c-0.3,0-0.6,0.3-0.6,0.6v0.6h-3.5c-0.3,0-0.6,0.3-0.6,0.6c0,0.3,0.3,0.6,0.6,0.6h11.7 c0.3,0,0.6-0.3,0.6-0.6c0-0.3-0.3-0.6-0.6-0.6h-3.5v-0.6c0-0.3-0.3-0.6-0.6-0.6H18.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M18.3,18.6c0.3,0,0.6,0.3,0.6,0.6V25c0,0.3-0.3,0.6-0.6,0.6s-0.6-0.3-0.6-0.6v-5.8C17.7,18.8,18,18.6,18.3,18.6 z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M22.3,19.2c0-0.3-0.3-0.6-0.6-0.6c-0.3,0-0.6,0.3-0.6,0.6V25c0,0.3,0.3,0.6,0.6,0.6c0.3,0,0.6-0.3,0.6-0.6V19.2 z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M15,16.3c0-0.3,0.3-0.6,0.6-0.6h8.8c0.3,0,0.6,0.2,0.6,0.6l0.2,1.5c0.3,2.7,0.3,5.5,0,8.2l0,0.1 c-0.1,1.1-1,1.9-2,2.1c-2.1,0.3-4.2,0.3-6.2,0c-1.1-0.2-1.9-1-2-2.1l0-0.1c-0.3-2.7-0.3-5.5,0-8.2L15,16.3z M16.2,17l-0.1,0.9 c-0.3,2.6-0.3,5.3,0,7.9l0,0.1c0.1,0.5,0.5,0.9,1,1c2,0.3,3.9,0.3,5.9,0c0.5-0.1,0.9-0.5,1-1l0-0.1c0.3-2.6,0.3-5.3,0-7.9L23.8,17 H16.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashCircle);
export default __webpack_public_path__ + "static/media/TrashCircle.b71d8559a0f516a185865e0b669f3966.svg";
export { ForwardRef as ReactComponent };